const gap = '\u00A0\u00A0';

/**
 * Короткий хвост вроде «50%» остаётся на одной строке с предыдущим словом.
 * Длинное продолжение может перенестись, но новая строка не начинается с тире.
 * Диапазоны вроде 2–3 не трогаем.
 */
export function glueDash(text: string): string {
  const withShortTail = text.replace(
    /(\S+)[ \u00A0]+([—–])[ \u00A0]+(\S{1,12})(?=$|[\s,.;:!?])/g,
    (_, word: string, dash: string, tail: string) => `${word}${gap}${dash}${gap}${tail}`,
  );
  return withShortTail.replace(/([ \u00A0])([—–]) /g, `\u00A0$2\u2004`);
}
